export type Option = {
  value: string;
  label?: string;
  onlyImbroA?: boolean;
};

export const optionalIndicationYesNoOptions = [
  {
    value: "ja",
    label: "Ja",
  },
  {
    value: "nee",
    label: "Nee",
  },
  {
    value: "",
    label: "Niet van toepassing",
  },
] as const;
export const optionalIndicationYesNoOptionsType = optionalIndicationYesNoOptions.map(
  ({ value }) => value
);
export type OptionalIndicationYesNoOptions = (typeof optionalIndicationYesNoOptionsType)[number];

export const indicationYesNoOptions = [
  {
    value: "ja",
    label: "Ja",
  },
  {
    value: "nee",
    label: "Nee",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export const indicationYesNoOptionsType = indicationYesNoOptions.map(({ value }) => value);
export type IndicationYesNoOptions = (typeof indicationYesNoOptionsType)[number];

export const yesNoOptions = [
  {
    value: "ja",
    label: "Ja",
  },
  {
    value: "nee",
    label: "Nee",
  },
] as const;
export const yesNoOptionsType = yesNoOptions.map(({ value }) => value);
export type YesNoOptions = (typeof yesNoOptionsType)[number];
